import { render, staticRenderFns } from "./DashboardCompont.vue?vue&type=template&id=75fa3c5f"
import script from "./DashboardCompont.vue?vue&type=script&lang=js"
export * from "./DashboardCompont.vue?vue&type=script&lang=js"
import style0 from "./DashboardCompont.vue?vue&type=style&index=0&id=75fa3c5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports